// @ts-nocheck 

import { Instance, types } from "mobx-state-tree"
import { MessageRtoModelBase } from "./MessageRtoModel.base"

/* The TypeScript type of an instance of MessageRtoModel */
export interface MessageRtoModelType extends Instance<typeof MessageRtoModel.Type> {}

/* A graphql query fragment builders for MessageRtoModel */
export { selectFromMessageRto, messageRtoModelPrimitives, MessageRtoModelSelector } from "./MessageRtoModel.base"

/**
 * MessageRtoModel
 *
 * Message RTO
 */
export const MessageRtoModel = MessageRtoModelBase.props({
  uuid: types.optional(types.string, new Date().getTime().toString()),
})
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
